export default [
  {
    label: 'TESTING',
    routerLink: '/TestingModule',
    routerLinkActiveOptions: {
      exact: false,
    },
    disabled: false,
    styleClass: 'uppercase',
    items: [],
  },
  {
    label: 'ONBOARDING',
    routerLinkActiveOptions: {
      exact: false,
    },
    disabled: true,
    styleClass: 'uppercase',
    items: [
      {
        items: [
          {
            label: 'MEMBER',
            routerLink: '/OnboardingModule/MemberOnboarding',
            disabled: true,
          },
          {
            label: 'SUPPLIER',
            routerLink: '/OnboardingModule/SupplierOnboarding',
            disabled: true,
          },
        ],
      },
    ],
  },
{
    label: 'HELP',
    routerLinkActiveOptions: {
      exact: false,
    },
    disabled: false,
    styleClass: 'uppercase',
    items: [
      {
        items: [
          {
            label: 'CONTACT_SUPPORT',
            routerLink: '/ContactSupport',
            disabled: false,
          },
          {
            label: 'LBMX_DOCUMENT_SPECIFICATIONS',
            routerLink: '/DocumentSpecification',
            disabled: false,
          },
          {
            label: 'TEST_TOOL_GUIDE',
            routerLink: '/TestToolGuide',
            disabled: true,
          },
        ],
      },
    ],
  },
  {
    label: 'ADMINISTRATION_DROPDOWN',
    icon: 'pi pi-cog',
    routerLink: '/AdministrationModule',
    routerLinkActiveOptions: {
      exact: true,
    },
    pan: 'right',
    disabled: true,
    styleClass: 'uppercase',
    items: [],
  },
  {
    label: 'PROFILE',
    routerLink: '/UserModule',
    routerLinkActiveOptions: {
      exact: true,
    },
    icon: 'pi pi-user',
    pan: 'right',
    disabled: true,
    styleClass: 'uppercase',
    items: [
      {
        items: [
          {
            label: 'PROFILE',
            routerLink: '/UserModule/userProfile',
            disabled: true,
          },
          {
            label: 'LOG_OUT',
            routerLink: '/logout',
            disabled: true,
          },
        ],
      },
    ],
  },
];
